import React, {
  ButtonHTMLAttributes,
  PropsWithChildren,
  useState,
} from 'react';
import { Tooltip } from '@/Components/Tooltip';

export type ButtonProps = {
  className?: string;
} & PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>;

type CopyButtonProps = ButtonProps & {
  content: string;
};

export default function CopyContentButton({
  children,
  content,
  ...props
}: CopyButtonProps) {
  const [message, setMessage] = useState<string>('Copy File Contents');
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    // Execute the parent's onClick handler if it's provided
    if (
      React.isValidElement(children) &&
      typeof children.props.onClick === 'function'
    ) {
      children.props.onClick(e);
    }

    try {
      await navigator.clipboard.writeText(content);
      setMessage('Copied!');
      setTimeout(() => {
        setMessage('Copy File Contents');
      }, 1000);
    } catch (err) {
      setMessage('Error');
    }
    setTooltipOpen(true);
  };

  const wrappedChildren = React.cloneElement(children as React.ReactElement, {
    onClick: handleClick,
    ...props,
  });

  return (
    <Tooltip message={message} open={tooltipOpen} onOpenChange={setTooltipOpen}>
      {wrappedChildren}
    </Tooltip>
  );
}
